import React from 'react';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import Helmet from 'react-helmet';
import 'assets/css/style.scss';
import { RoutePlanner } from 'screens/routePlanner';
import LocaleProvider from './containers/LocaleContext';
import { Map } from 'screens/map/Map';
import store from 'store/store';
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';
const RouteWithTitle = ({ title, path, component }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("title", null, title)),
        React.createElement(Route, { path: path, component: component })));
};
const Root = () => {
    const gtmParams = { id: 'GTM-PJL9RH' };
    return (React.createElement(Provider, { store: store },
        React.createElement(GTMProvider, { state: gtmParams },
            React.createElement(LocaleProvider, null,
                React.createElement(Switch, null,
                    React.createElement(RouteWithTitle, { title: "Fastned Map", path: "/map", component: Map }),
                    React.createElement(RouteWithTitle, { title: "Fastned Route Planner", path: "/route-planner", component: RoutePlanner }))))));
};
export default Root;
